import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { signForumImages } from "@/lib/forum.functions";

export function ForumImages({ paths, className = "" }: { paths: string[]; className?: string }) {
  const sign = useServerFn(signForumImages);
  const usable = (paths ?? []).filter(Boolean);

  const { data } = useQuery({
    queryKey: ["forum-images", usable.join("|")],
    queryFn: () => sign({ data: { paths: usable } }),
    enabled: usable.length > 0,
    staleTime: 1000 * 60 * 60,
  });

  if (!usable.length) return null;

  const urls = usable.map((p) => (p.startsWith("http") ? p : data?.urls?.[p])).filter(Boolean) as string[];
  if (!urls.length) return null;

  return (
    <div
      className={`grid gap-2 ${urls.length > 1 ? "grid-cols-2" : "grid-cols-1"} ${className}`}
    >
      {urls.map((url) => (
        <a key={url} href={url} target="_blank" rel="noreferrer" className="overflow-hidden rounded-2xl border border-border">
          <img src={url} alt="" loading="lazy" className="h-full w-full object-cover" />
        </a>
      ))}
    </div>
  );
}
